import { render, staticRenderFns } from "./navBreadcrumbs.vue?vue&type=template&id=d28a86c2&scoped=true"
import script from "./navBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./navBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./navBreadcrumbs.vue?vue&type=style&index=0&id=d28a86c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28a86c2",
  null
  
)

export default component.exports